// BidLight pricing — mirrors the public pricing pages
// (bidlight-portal utils/PricingComponentData.js). Keep the two in step.
//
// Every plan below is the COORDINATION package: Basics, Core, Complete and
// Max differ in which coordination sub-features are switched on. Estimation
// is sold separately as the estimation packages (`estimationPackages`).
// Enterprise is on both lists: one flat price, unlimited licences, the
// coordination workspace AND the estimation package.
//
// `title` must match the Stripe product name — /stripe/stripeproducts pairs
// plans to Stripe products by name.
// `amount` is the price per licence billed annually; `monthly` the same
// licence billed month to month; `flat: true` means one price for the
// company (unlimited licences), shown per month.
export const pricingData = [
    {
        title: 'Basics',
        label: false,
        description: `For raising issues and taking part<br/>
        in coordination.`,
        amount: 260,
        monthly: 30,
        points: [
            'View the project and its 3D model',
            'Raise issues and take part in issue threads',
            'See who is on the project',
            'Email support and BidLight Learning',
        ]
    },
    {
        title: 'Core',
        label: false,
        description: `For running issues and collaborating<br/>
        with partners.`,
        amount: 330,
        monthly: 39,
        points: [
            'Everything in Basics',
            'Edit, assign, share and close issues by trade',
            'Model export history and element-level diffs from Revit',
            'Checklists and meeting minutes',
            'See the schedule and report progress',
            'Bring partner companies in; manage projects, users and roles',
        ]
    },
    {
        title: 'Complete',
        label: 'Most Popular',
        description: `For controlling the plan,<br/>
        reviews and documents.`,
        amount: 440,
        monthly: 51,
        points: [
            'Everything in Core',
            'Build the plan — Gantt, milestones and schedule import',
            'Review Center — resolution tracking and the approval queue',
            'Revisions and document control',
            'Disciplines, filters, parameters, export settings and WBS',
            'Team intelligence and automatic model-health suggestions',
        ]
    },
    {
        title: 'Max',
        label: 'Most Powerful',
        description: `For every coordination<br/>
        capability.`,
        amount: 590,
        monthly: 69,
        points: [
            'Everything in Complete',
            'Analytics & Performance dashboards with export',
            'Resource, engineering and asset tracking',
            'Kanban, project tracking and sharing',
            'Reports & notifications console',
            'API access and custom integrations',
        ]
    },
    {
        title: 'Enterprise',
        label: false,
        description: `Everything in BidLight: coordination and estimation,<br/>
        for as many licences as you need.`,
        // Sold by conversation: no price shown; contact us on bidlight.com.
        amount: null,
        monthly: null,
        flat: false,
        points: [
            'Everything in Max',
            'The full Estimation Package included for every licence',
            'Unlimited licences — pricing arranged with our team',
            'Custom integrations and a dedicated account manager',
            'Invoiced billing and 24/7 support',
        ]
    },
];

// Estimation packages — sold on bidlight.com/estimation, stacked on top of
// the company's coordination plan, monthly or annually; a ladder of their
// own. Enterprise is the same flat monthly-only product as above.
export const estimationPackages = [
    {
        title: 'Solo',
        label: false,
        description: `Perfect for independent designers.<br/>
        Start your journey with BidLight 3.0!`,
        amount: 2388,
        monthly: 279,
        points: [
            'Estimation inside BIM (Revit)',
            'Estimation history — see and export every estimate',
            'BidLight pricing database',
        ]
    },
    {
        title: 'Studio',
        label: false,
        description: `Built for agile studios.<br/>
        Collaborate seamlessly with your team!`,
        amount: 5988,
        monthly: 699,
        points: [
            'Everything in Solo',
            'Real-time estimate while you model',
            'Share estimates with your team and clients',
            'Build your own price database and compare prices',
            'Filters and parameters — 2D takeoff and quantity workflows',
        ]
    },
    {
        title: 'Business',
        label: 'Most Popular',
        description: `Scale your operations efficiently.<br/>
        Perfect for fast-growing businesses!`,
        amount: 11988,
        monthly: 1399,
        points: [
            'Everything in Studio',
            'Estimate diff analytics between revisions',
            'Export settings and custom templates',
            'Asset and engineering tracking, kanban boards',
            'Affiliations and priority support',
        ]
    },
    {
        title: 'Enterprise',
        label: false,
        description: `Everything in BidLight: coordination and estimation,<br/>
        for as many licences as you need.`,
        // Sold by conversation: no price shown; contact us on bidlight.com.
        amount: null,
        monthly: null,
        flat: false,
        points: [
            'Everything in Business',
            'The full coordination workspace (Max plan) included for every licence',
            'Unlimited licences — pricing arranged with our team',
        ]
    },
];

export const reviewsData = [
    
    {
        user: 'Will Moore',
        review: 'BidLight eased me through every step of the estimating process.  I particularly liked the flexibility of the program, simple adjustment process and seamless integration with Revit.',
        company: 'Southern Concepts Design Build',
        image: require('assets/images/willmoore.jpg'),
    },
    {
        user: 'Mary Ann Jones',
        review: 'Simply, now we are capable of designing complex and custom projects under budget',
        company: 'Hensel Architects, LLC',
        image: require('assets/images/mj.jpg'),
    },
    {
        user: 'John Theis',
        review: 'Providing pre-con with initial estimates and quantities, is a huge help!',
        company: 'CBT, INC',
        image: require('assets/images/jt.jpg'),
    },
    {
        user: 'Gerry Thomas',
        review: 'Thanks to Bidlight, we now have the capability to generate rough estimates early on, in the bidding cycle',
        company: 'Better Built, INC',
        image: require('assets/images/gt.jpg'),
    }
]